import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import API from "../lib/api";
import { ArrowLeft, ArrowRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/blog").then(r => setPosts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F0F0F0]" data-testid="blog-page">
      <nav className="border-b border-[#1E1E1E]">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="font-heading text-xl font-black tracking-tighter uppercase" data-testid="blog-nav-logo">
            NRD<span className="text-[#00FF41]">.</span>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#00FF41] transition-colors" data-testid="blog-back-home">
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </nav>

      <div className="max-w-7xl mx-auto px-6 py-16">
        <p className="text-xs font-mono uppercase tracking-[0.2em] text-[#00FF41] mb-3">Blog</p>
        <h1 className="font-heading text-4xl lg:text-5xl font-black tracking-tighter uppercase mb-16" data-testid="blog-title">Insights & Guides</h1>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-6 h-6 border-2 border-[#00FF41] border-t-transparent animate-spin" />
          </div>
        ) : posts.length === 0 ? (
          <p className="text-sm text-slate-500">No posts yet. Check back soon.</p>
        ) : (
          <div className="grid md:grid-cols-3 gap-0 border border-[#1E1E1E]">
            {posts.map((post, i) => (
              <div key={post.id} className={`p-6 ${i % 3 < 2 ? 'border-r border-[#1E1E1E]' : ''} ${i < posts.length - 3 ? 'border-b border-[#1E1E1E]' : ''}`} data-testid={`blog-card-${i}`}>
                {post.cover_image && (
                  <div className="aspect-[16/9] overflow-hidden border border-[#1E1E1E] mb-4">
                    <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover opacity-70" />
                  </div>
                )}
                <span className="text-xs font-mono uppercase tracking-[0.2em] text-[#00FF41]">{post.category}</span>
                <h2 className="font-heading text-lg font-medium tracking-tight mt-2 mb-2">{post.title}</h2>
                <p className="text-sm text-slate-400 mb-4">{post.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-slate-600">{post.author}</span>
                  <Link to={`/blog/${post.id}`} className="text-sm font-medium text-[#00FF41] hover:text-[#00CC33] flex items-center gap-1" data-testid={`blog-read-${post.id}`}>
                    Read <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
